import React, { useRef, useState } from 'react';
import { useTheme, styled } from '@mui/material/styles';
import {
    Button,
    Grid,
    Snackbar,
    Input,
    InputLabel,
    Chip,
    Typography
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import AlertComponent from 'src/components/Alert';
// project imports
import SubCard from 'src/components/cards/SubCard';
import 'react-dropzone-uploader/dist/styles.css';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'src/utils/axios';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css'


const UploadPhoto = ({ EmployeeImage, EmployeeNr, ServiceShopId, setOpenProfileImageUploadPopUp, setAvatarEmployee, setWarning, setWarningType, setresponseMessage }) => {
    const theme = useTheme();
    const [displayedImage, setDisplayedImage] = useState(EmployeeImage);
    const [displayedImageName, setDisplayedImageName] = useState();
    const [crop, setCrop] = useState(null);
    const imageRef = useRef(null);


    const changeDisplayedImage = (e) => {
        const file = e.target.files[0];

        const reader = new FileReader();
        reader.onload = (e) => {
            setDisplayedImage(e.target.result);
            setDisplayedImageName(file.name);
        };
        reader.readAsDataURL(file);
    };

    const handleSaveImage = () => {
        if (!displayedImage) {
            setWarning(true);
            setWarningType("error");
            setresponseMessage("Lütfen önce bir fotoğraf yükleyin!");
            return;
        }

        let finalBase64 = displayedImage

        if (imageRef.current && crop?.width && crop?.height) {
            const cropped = getCroppedImage(crop);
            if (cropped) {
                finalBase64 = cropped;
            }
        }

        var data = {
            ServiceShopId: ServiceShopId,
            EmployeeId: EmployeeNr,
            ImageBase64: finalBase64.split(',')[1]
        };

        var headers = {
            'Content-Type': 'application/json',
        };
        axios.post('/SetEmployeeImage', data, headers).then((response) => {
            if (response.data.ErrorCode == "0") {
                setOpenProfileImageUploadPopUp(false);
                setAvatarEmployee(finalBase64);
                setresponseMessage(response.data.ErrorDescription);
                setWarning(true);
                setWarningType("success");
            } else {
                setresponseMessage(response.data.ErrorDescription);
                setWarning(true);
                setWarningType("error")
            }
        }
        );
    };

    const handleDelete = () => {
        setDisplayedImageName(null);
        setDisplayedImage(displayedImage);
    };

    const onDragOver = (e) => {
        e.preventDefault();
    };

    const onDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (!file || !file.type.startsWith('image/')) {
            return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            setDisplayedImage(e.target.result);
            setDisplayedImageName(file.name);
        };
        reader.readAsDataURL(file);
    };

    const getCroppedImage = (crop) => {
        const image = imageRef.current;
        if (!image || !crop.width || !crop.height) return null;

        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return canvas.toDataURL("image/jpeg");
    };


    return (
        <>
            <Grid>
                <SubCard contentSX={{ textAlign: 'center' }}
                    onDragOver={onDragOver}
                    onDrop={onDrop}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <SubCard contentSX={{ textAlign: 'center' }}>
                                <ReactCrop crop={crop} onChange={c => setCrop(c)}>
                                    <img src={displayedImage} ref={imageRef} alt="crop source" />
                                </ReactCrop>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{ mt: 1, fontStyle: 'italic' }}
                                >
                                    Fotoğrafı kırpmak için tıklayıp kırpacağınız alanı seçin, kenarlardan tutarak boyutlandırın.
                                </Typography>
                            </SubCard>
                        </Grid>
                        <Grid item xs={12}>
                            <div>
                                <Input
                                    type="file"
                                    id="file-upload"
                                    onChange={changeDisplayedImage}
                                    fullWidth
                                    sx={{ display: 'none', visibility: 'hidden' }} />
                                <InputLabel
                                    htmlFor="file-upload"
                                    sx={{
                                        background: theme.palette.background.default,
                                        py: 3.75,
                                        px: 0,
                                        textAlign: 'center',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        mb: 3,
                                        '& > svg': {
                                            verticalAlign: 'sub',
                                            mr: 0.5
                                        }
                                    }}
                                >
                                    <CloudUploadIcon /> Fotoğrafı buraya sürükleyin veya seçin
                                </InputLabel>
                                {displayedImageName ? <Chip
                                    label={displayedImageName}
                                    variant="outlined"
                                    onDelete={handleDelete}
                                /> : null}
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleSaveImage}

                            >
                                Kaydet
                            </Button>
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>
        </>
    );
};

export default UploadPhoto;
